// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { getHours as fn } from "../getHours.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const getHoursWithOptions = convertToFP(fn, 2);

// Fallback for modularized imports:
export default getHoursWithOptions;
